export default `<% _.each(data, function (selectionName) { %>
<option value="<%= selectionName %>"><%= selectionName %></option>
<% }); %>`;